<template lang="pug">
   MDashboardWidget( title="Reasons Report by ALP" )

    div(class="form-group row")

      div(class="col-sm-10")
        label Date range
        input( type="date" placeholder="End date" class="form-control" v-model="startDate" )
        input( type="date" placeholder="Start date" class="form-control" v-model="endDate" )
      
      div(class="col-sm-10 mt-3")
        label Advertiser ALP
        input( type="text" placeholder="Advertiser ALPs (comma-separated)" class="form-control" v-model="alps" )
        p( class="text-left mt-3" )
          button( class="btn btn-details btn-outline btn-info" v-bind:disabled="! alps || loading" v-on:click="generateAuditsWithReasonsReportAlp" )
            i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
            | Generate CSV for download
        
        p( class="text-danger m-0" v-if="errorMessage" ) {{ errorMessage }}
</template>
<script>
import Vue from 'vue'
import gql from 'graphql-tag'
import * as dateFormat from 'dateformat'
export default Vue.extend({

  data(){
    return{
      startDate: dateFormat(new Date(Date.now() - (69 * 24 * 60 * 60 * 1000)), 'yyyy-mm-dd'),
      endDate: dateFormat(new Date(), 'yyyy-mm-dd'),
      loading: false,
      alps: '',
      errorMessage: ''
    }
  },

  methods: {

    async csvFromReasons() {
      this.loading = true

      const { data: { csvAuditsWithReason }} = await this.$apollo.query({
        query: gql`
          query CSVAuditsWithReason($reasonId: [String]!) {
            csvAuditsWithReason(
              reasonId: $reasonId
            )
          }
        `,
        variables: {
          reasonId: this.reasonId
        },
      }) 

      this.$moonpull.downloadCsv(data, 'report.csv')

      this.loading = false
    }

  }
})
</script>